import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { AuthSubscriptionService, LanguageService, MenuBaseComponent, ValidationHandlerService } from 'lib/Vestra.shared';
import { CoreService, AuthenticationService } from 'src/app/services/api-services';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
    selector: 'app-menu',
    templateUrl: './menu.component.html',
    styleUrls: ['./menu.component.scss'],
})
export class MenuComponent extends MenuBaseComponent {
    title = 'Vestra.admin-site';

    constructor(
        protected override coreService: CoreService,
        protected override authenticationService: AuthenticationService,
        protected override validationHandlerService: ValidationHandlerService,
        protected override translateService: TranslateService,
        protected override modalService: BsModalService,
        protected override spinnerService: NgxSpinnerService,
        protected override languageService: LanguageService,
        protected override authSubscriptionService: AuthSubscriptionService
    ) {
        super(coreService, authenticationService, validationHandlerService, translateService, modalService, spinnerService, languageService, authSubscriptionService);
    }

    public override ngOnInit(): void {
        super.ngOnInit();
    }

    public override ngOnDestroy(): void {
        super.ngOnDestroy();
    }

    public get isAdmin() {
        return this.authenticationService.isAdmin();
    }
    public get canSeeMessages() {
        return this.authenticationService.canSeeMessages();
    }
    public get canSeeSettings() {
        return this.authenticationService.canSeeSettings();
    }
    public get canSeeAffiliates() {
        return this.authenticationService.canSeeAffiliates();
    }
    public get canSeeProducts() {
        return this.authenticationService.canSeeProducts();
    }
    public get canSeeProspects() {
        return this.authenticationService.canSeeProspects();
    }
    public get canSeeReport() {
        return this.authenticationService.canSeeReport();
    }
    public get canSeeSoftware() {
        return this.authenticationService.canSeeSoftware();
    }
    public get canSeeMarketing() {
        return this.authenticationService.canSeeMarketing();
    }
    public get canSeeProviders() {
        return this.authenticationService.canSeeProviders();
    }
}
